export const EVENT_ANALYTICS_ACTIVATED = 'Analytics_Activated';
export const EVENT_ANALYTICS_TYPE_SELECTED = 'Analytics_Type_Selected';
export const EVENT_ANALYTICS_TYPE_UPDATED = 'Analytics_Type_Updated';
export const EVENT_VALIDATION_ACTIVATED = 'Validation_Activated';
export const EVENT_VALIDATION_INSITU_SELECTED = 'Validation_InSitu_Selected';
export const EVENT_VALIDATION_SATELLITE_SELECTED =
  'Validation_Satellite_Selected';
export const EVENT_VALIDATION_INSITU_UPDATED = 'Validation_InSitu_Updated';
export const EVENT_LOCALMODEL_POINT_CREATED = 'LocalModel_Point_Created';
export const EVENT_DATA_ADDED_TO_CART = 'Data_Added_To_Cart';
export const EVENT_DATA_DOWNLOADED = 'Data_Downloaded';

export const EVENT_DESC_SEPARATOR = '; ';
export const EVENT_DESC_LOCATION = 'location: ';
export const EVENT_DESC_LOCATION_SEPARATOR = ', ';
export const EVENT_DESC_DATASET = 'dataset: ';
export const EVENT_DESC_TYPE = 'type: ';

export function trackUpdate(
  eventType: string,
  coordinates: Array<number>,
  datasetId: string,
  type: string
) {
  const _paq = (window._paq = window._paq || []);
  const typeInfo = type ? EVENT_DESC_SEPARATOR + EVENT_DESC_TYPE + type : '';
  _paq.push([
    'trackEvent',
    eventType,
    EVENT_DESC_LOCATION +
      coordinates.join(EVENT_DESC_LOCATION_SEPARATOR) +
      EVENT_DESC_SEPARATOR +
      EVENT_DESC_DATASET +
      datasetId +
      typeInfo,
  ]);
}
